'use client';

import type { MouseEvent, ReactNode } from 'react';
import styled from 'styled-components';

import { Close } from '@zoomit/icons';
import { Box, Flex, IconButton, Spacing } from '@zoomit/primitives';

import { theme } from '../../theme';
import { Hr } from '../hr';
import { Typography } from '../typography';

type Props = {
  title: string;
  onClose: () => void;
  children?: ReactNode;
};

export const ModalHead = (props: Props) => {
  const { children, title, onClose, ...rest } = props;

  const handleClose = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClose();
  };

  return (
    <div>
      <Box
        className={'bg-card flex items-center justify-between rounded-t-sm'}
        spacing={{ px: Spacing.x6, py: Spacing.x4 }}
      >
        <Title fontSize={1.6} fontWeight={900}>
          {title}
        </Title>
        <Flex justifyContent="space-between" alignItems="center" gap={2.4}>
          {children}
          <IconButton data-test="close_modal" onClick={handleClose} autoFocus {...rest}>
            <Close size="dl" />
          </IconButton>
        </Flex>
      </Box>
      <Hr />
    </div>
  );
};

const Title = styled(Typography)`
  position: relative;
  margin: 0;
  display: inline;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: -2.4rem;
    width: 4px;
    height: 100%;
    background-color: var(${theme.primary1});
  }
`;
